export default {"src":"/_next/static/media/0xf307910A4c7bbc79691fD374889b36d8531B08e3.3ff397f9.svg","height":379,"width":367,"blurWidth":0,"blurHeight":0};